export const ESA_AGGREGATOR_PAGE_FEATURE_FLAG = "esa-aggregator-page";
export const ESA_AGGREGATOR_BROWSE_PAGE_FEATURE_FLAG =
  "esa-aggregator-browse-page";
export const ESA_CREDITS_TO_WALLET_FEATURE_FLAG = "esa-credits-to-wallet";
export const EDUCATOR_ESA_HUB_FEATURE_FLAG = "educator-esa-hub";
export const FLEXIBLE_PAYMENT_METHOD_SELECTION_FEATURE_FLAG =
  "flexible-payment-method-selection";
export const BACK_TO_SCHOOL_HOMEPAGE_2026_FEATURE_FLAG =
  "back-to-school-homepage-2026";
export const ACADEMICS_PARENT_SIDE_FEATURE_FLAG = "academics-parent-side";
export const CALIFORNIA_MANDATED_REPORTER_TRAINING_CREDENTIAL_FEATURE_FLAG =
  "ca-mandated-reporter-training-credential";
export const CALIFORNIA_MANDATED_REPORTER_TRAINING_PHASE3_FEATURE_FLAG =
  "ca-mandated-reporter-training-phase3";
export const HEIP_RECEIPT_FEATURE_FLAG = "heip-receipt";
